import axios from 'axios'

const MANIFEST_NAME = 'manifest.json'

export async function loadMicroApp (scope, module) {
  // Initializes the share scope. This fills it with known provided modules from this build and all remotes
  /* eslint-disable */
  await __webpack_init_sharing__('default')

  const container = window[scope] // or get the container somewhere else
  // Initialize the container, it may provide shared modules
  await container.init(__webpack_share_scopes__.default)
  /**
   * REFACTO THIS WHEN ALL MODULE ARE ARRAY
   */
  if (Array.isArray(module)) {
    const createdModules = {}
    for (const mod of module) {
      const factory = await window[scope].get(mod)
      const Module = factory()
      createdModules[mod] = Module
      const moduleName = mod.split('/').pop()
      window[moduleName] = Module.default
    }
    return createdModules
  } else {
    const factory = await window[scope].get(module)
    const Module = factory()
    return Module
  }
}

export async function loadMicroManifest (baseUrl) {
  try {
    const { data } = await axios.create().get(`${baseUrl}${MANIFEST_NAME}`, { withCredentials: false })
    return data
  } catch (error) {
    console.error(error)
    console.error('Manifest error: ' + baseUrl)
  }
}

export function loadMicroScript(urlScript) {
  return new Promise( (resolve, reject) => {
    const element = document.createElement('script')
    element.src = urlScript
    element.type = 'text/javascript'
    element.async = true
    document.head.appendChild(element)
    element.onload = async () => {
      resolve()
    }
    element.onerror = () => {
      console.error('Micro error loading script : ' + urlScript)
      reject()
    }
  })
}